import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { MetricsService } from '@jeppesen-foreflight/jmkw-analytics';
import { BasicButtonComponent } from '@jeppesen-foreflight/jmkw-toolkit';
import { TerrainLegendComponent } from './terrain-legend.component';
import { TerrainPluginService } from './terrain.plugin.service';
import { AVIATION_CONFIG_TOKEN } from '../aviation/aviation.config';
import { JmkwAviationConfig } from '../types/jeppesen.environment';

@NgModule({
  imports: [
    TerrainLegendComponent,
    BasicButtonComponent,
    CommonModule
  ],
  providers: [TerrainPluginService, MetricsService]
})
export class TerrainPluginModule {
  static forRoot(
    aviationConfig: Partial<JmkwAviationConfig>
  ): ModuleWithProviders<TerrainPluginModule> {
    return {
      ngModule: TerrainPluginModule,
      providers: [
        {
          provide: AVIATION_CONFIG_TOKEN,
          useValue: aviationConfig
        }
      ]
    };
  }
}
